(() => {
  if (window.smdEnhancementLoader) return;
  const loaded = new Map(), observed = new WeakSet();
  const load = node => {
    const url = node.dataset.smdEnhancementSrc;
    if (!url) return;
    if (!loaded.has(url)) {
      loaded.set(url, new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url; script.async = true;
        script.onload = resolve; script.onerror = reject;
        document.head.append(script);
      }));
    }
    loaded.get(url).then(() => {
      if (node.matches('[data-smd-flex-carousel]')) window.smdFlexCarousel?.mount(node);
      if (node.matches('[data-smd-drift-wall]')) window.smdDriftWall?.scan();
    }).catch(() => loaded.delete(url));
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { observer.unobserve(entry.target); load(entry.target); } });
  }, { rootMargin: '160px' }) : null;
  const scan = () => document.querySelectorAll('[data-smd-enhancement-src]').forEach(node => {
    if (observed.has(node)) return;
    observed.add(node);
    if (observer) observer.observe(node); else load(node);
  });
  window.smdEnhancementLoader = { scan };
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
